import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'underscore';

import AlternateChannels from './AlternateChannels';
import DefaultAppIcon from './DefaultAppIcon';

import { setIntroHeight } from '../actions/app-state';

import { createMarkup } from '../utils/html';
import { getAppChannelDetails } from '../utils/app';

export class IntroductionComponent extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        appState: PropTypes.object.isRequired,
        config: PropTypes.object.isRequired,
        channelsAvailable: PropTypes.bool.isRequired,
        channelDetailsList: PropTypes.array,
        introAppText: PropTypes.string.isRequired,
        introductionText: PropTypes.string.isRequired,
    };

    constructor(...args) {
        super(...args);
        this._debounceClientHeightCalculation = _.debounce(this.calculateIntroHeight.bind(this), 150);
    }

    componentDidMount() {
        // Height of Introduction component will be computed on render and on resize only
        window.addEventListener('resize', this._debounceClientHeightCalculation);
        setTimeout(this.calculateIntroHeight.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._debounceClientHeightCalculation);
    }

    componentDidUpdate() {
        setTimeout(this.calculateIntroHeight.bind(this));
    }

    calculateIntroHeight() {
        const {
            appState: { introHeight },
            dispatch,
        } = this.props;
        const node = this._introductionContainer;

        if (node) {
            const nodeHeight = node.offsetHeight;

            if (introHeight !== nodeHeight) {
                dispatch(setIntroHeight(nodeHeight));
            }
        }
    }

    render() {
        const { config, introductionText, introAppText, channelDetailsList, channelsAvailable } = this.props;
        const introText = channelsAvailable ? `${introductionText} ${introAppText}` : introductionText;

        const classes = ['intro-pane'];

        if (config.fixedIntroPane) {
            classes.push('fixed');
        }

        return (
            <div className={classes.join(' ')} ref={(c) => (this._introductionContainer = c)}>
                {config.businessIconUrl ? (
                    <img className="app-icon" alt="App icon" src={config.businessIconUrl} />
                ) : (
                    <DefaultAppIcon />
                )}
                <div className="app-name">{config.businessName}</div>
                <div className="intro-text" dangerouslySetInnerHTML={createMarkup(introText)} />
                {channelsAvailable ? <AlternateChannels items={channelDetailsList} /> : null}
            </div>
        );
    }
}

export default connect(
    ({ config, appState: { introHeight, widgetState, activeConversationId }, conversations, ui: { text } }) => {
        const conversation = conversations[activeConversationId];
        const channelDetailsList = getAppChannelDetails(config.integrations, config.integrationOrder);

        return {
            config,
            appState: {
                introHeight,
                widgetState,
            },
            channelDetailsList: conversation.isDefault
                ? getAppChannelDetails(config.integrations, config.integrationOrder)
                : null,
            channelsAvailable: conversation.isDefault && channelDetailsList.length > 0,
            introAppText: text.introAppText,
            introductionText: text.introductionText,
        };
    },
)(IntroductionComponent);
